var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8275 0.110674C10.6809 -0.0368914 10.4424 -0.0368914 10.2969 0.110674L4.70564 5.67765C4.55912 5.82622 4.32008 5.82622 4.17456 5.67765L1.72473 3.18204C1.65222 3.10801 1.55721 3.07149 1.4617 3.07099C1.36518 3.07049 1.26717 3.10701 1.19366 3.18204L0.111015 4.15547C0.0390053 4.22951 0 4.32205 0 4.41859C0 4.51563 0.0390053 4.61718 0.111515 4.69071L2.58185 7.28386C2.72787 7.43193 2.9674 7.67204 3.11292 7.8191L4.17507 8.89008C4.32108 9.03664 4.55962 9.03664 4.70614 8.89008L11.8901 1.71689C12.0366 1.56982 12.0366 1.32822 11.8901 1.18115L10.8275 0.110674Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1908fe39db6baa14d18d3cb2d4b2d4b5.svg";
export { ForwardRef as ReactComponent };